import { Pipe, PipeTransform } from '@angular/core';
import { TemplateField } from '../../models/template.model';
import { ReportFieldFormatterService } from '../../report-field-formatter.service';
import { ReportOptions, ReportRecord } from '../../models/report.model';

@Pipe({ name: 'isFieldVisible' })
export class IsFieldVisiblePipe implements PipeTransform {
  constructor(private reportFieldFormatterService: ReportFieldFormatterService) {}

  transform(
    record: ReportRecord | ReportRecord[],
    settings: {
      templateId: number;
      field: TemplateField;
      reportOptions?: ReportOptions;
    }
  ): boolean {
    return this.reportFieldFormatterService.isFieldVisible(record, settings);
  }
}
